module.exports = __webpack_public_path__ + "img/calendar.6998b224.svg";